import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import menus from '../menus';

class Header extends Component {

    render() {
        return (
            <header>
                <div className="site-navigation " id="mainmenu-area">
                    <nav className="navbar navbar-expand-lg">
                        <div className="container">
                            <Link to="https://marlenepuertas.com" className="navbar-brand">
                                {/* Agregado: atributo alt para accesibilidad */}
                                <img src="assets/images/logomp.jpg" alt="Marlene Puertas Ramírez" style={{ width: '150px', height: 'auto' }} className="img-fluid"/>
                            </Link>

                            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMenu" aria-controls="navbarMenu" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="fa fa-bars"></span>
                            </button>

                            <div className="collapse navbar-collapse" id="navbarMenu">
                                <ul className="navbar-nav ms-auto">
                                    {/* Actualizado: dropdown vacío → HashLink funcional a #top-header */}
                                    <li className="nav-item">
                                        <HashLink to="#top-header" className="nav-link js-scroll-trigger">Inicio</HashLink>
                                    </li>
                                    {
                                        menus.map((menu) => (
                                            <li className="nav-item" key={menu.id}><HashLink to={menu.tomenu} className="nav-link js-scroll-trigger">{menu.namemenu}</HashLink></li>
                                        ))
                                    }
                                </ul>
                            </div>

                            <div className="header-right-info d-none d-lg-block">
                                <ul className="header-socials">
                                    <li><Link to="https://www.facebook.com/profile.php?id=61555680005672&mibextid=ZbWKwL"><i className="fab fa-facebook-f" aria-hidden="true" /></Link></li>
                                    <li><Link to="https://www.instagram.com/marlene.puertas_?igsh=MWF4ajlueGU4eDFycQ=="><i className="fab fa-instagram" aria-hidden="true" /></Link></li>
                                    <li><Link to="https://www.tiktok.com/@marlene.puertas?_t=8jh3VuuEPkk&_r=1"><i className="fab fa-tiktok" aria-hidden="true" /></Link></li>
                                    {/* Agregado: icono X con URL real */}
                                    <li><Link to="https://x.com/marlene_puertas?t=iFRQ536vclBwdIlywQTN8w&s=09" aria-label="X (Twitter)"><i className="fab fa-x-twitter" aria-hidden="true" /></Link></li>
                                </ul>
                            </div>
                        </div> 
                    </nav>
                </div>
            </header>
        );
    }
}

export default Header;
